const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaElectron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g4145",
    transform: "matrix(0.27778,5.70651e-33,-5.70651e-33,-0.27778,-55.1677,139.786)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path4147",
    x: 198.602,
    y: 326.621,
    width: 215.998,
    height: 137.208,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path4149",
    x: 202.198,
    y: 330.195,
    width: 208.798,
    height: 18.722,
    style: {
      fill: "rgb(247,182,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path4151",
    x: 202.198,
    y: 441.51,
    width: 208.798,
    height: 18.72,
    style: {
      fill: "rgb(26,31,113)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path4163",
    transform: "matrix(1,0,0,1,302.448,424.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L-10.464,-48.917L-23.12,-48.917L-12.656,0L0,0ZM53.24,-31.586L59.904,-13.216L63.732,-31.586L53.24,-31.586ZM67.367,-48.917L79.068,-48.917L68.845,0L58.049,0C55.614,0 53.568,-1.413 52.66,-3.586L33.67,-48.917L46.96,-48.917L49.596,-41.61L65.833,-41.61L67.367,-48.917ZM34.33,-32.946C34.383,-20.038 16.482,-19.322 16.599,-13.554C16.642,-11.801 18.312,-9.934 21.968,-9.457C23.779,-9.223 28.782,-9.036 34.449,-11.647L36.666,-1.268C33.621,-0.167 29.703,0.893 24.829,0.893C12.318,0.893 3.517,-5.752 3.447,-15.275C3.365,-22.319 9.733,-26.245 14.522,-28.591C19.455,-30.987 21.109,-32.527 21.086,-34.668C21.051,-37.95 17.147,-39.403 13.517,-39.457C7.152,-39.558 3.462,-37.737 0.519,-36.366L-1.778,-47.089C1.183,-48.446 6.64,-49.625 12.292,-49.685C25.592,-49.685 34.291,-43.116 34.33,-32.946M-18.085,0L-38.589,-48.917L-51.967,-48.917L-62.058,-9.877C-62.669,-7.478 -63.201,-6.595 -65.063,-5.581C-68.106,-3.928 -73.131,-2.382 -77.548,-1.42L-77.25,0L-55.713,0C-52.972,0 -50.504,-1.825 -49.877,-4.985L-44.545,-33.294L-31.382,0L-18.085,0Z",
    style: {
      fill: "rgb(26,31,113)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path4167",
    transform: "matrix(1,0,0,1,318.644,362.227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L-5.142,0L-5.142,-4.786L0.61,-4.786L0.61,-6.225L-6.875,-6.225L-6.875,7.053L0.315,7.053L0.315,5.614L-5.142,5.614L-5.142,1.419L0,1.419L0,0Z",
    style: {
      fill: "rgb(26,31,113)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path4169",
    x: 321.911,
    y: 356.002,
    width: 1.733,
    height: 13.986,
    style: {
      fill: "rgb(26,31,113)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "path4173",
    transform: "matrix(1,0,0,1,333.098,361.695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0C0.02,1.083 -0.453,2.797 -2.403,2.797C-4.176,2.797 -4.925,1.201 -5.063,0L0,0ZM-5.082,-1.241C-5.043,-3.586 -3.565,-4.551 -1.813,-4.551C-0.571,-4.551 0.197,-4.334 0.828,-4.059L1.143,-5.3C0.532,-5.575 -0.531,-5.91 -2.049,-5.91C-4.983,-5.91 -6.736,-3.96 -6.736,-1.084C-6.736,1.792 -5.043,4.038 -2.265,4.038C0.867,4.038 1.675,1.319 1.675,-0.434C1.675,-0.788 1.655,-1.044 1.615,-1.241L-5.082,-1.241Z",
    style: {
      fill: "rgb(26,31,113)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path4177",
    transform: "matrix(1,0,0,1,344.204,356.337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0C-0.453,-0.217 -1.458,-0.552 -2.738,-0.552C-5.614,-0.552 -7.485,1.398 -7.485,4.314C-7.485,7.249 -5.477,9.396 -2.364,9.396C-1.34,9.396 -0.434,9.141 0.039,8.884L-0.354,7.564C-0.769,7.781 -1.419,8.018 -2.364,8.018C-4.551,8.018 -5.732,6.383 -5.732,4.412C-5.732,2.206 -4.314,0.847 -2.423,0.847C-1.438,0.847 -0.788,1.083 -0.296,1.3L0,0Z",
    style: {
      fill: "rgb(26,31,113)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path4181",
    transform: "matrix(1,0,0,1,349.066,367.821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,-2.285L2.481,-2.285L2.481,-3.604L0,-3.604L0,-8.746C0,-9.929 0.335,-10.598 1.3,-10.598C1.772,-10.598 2.049,-10.559 2.305,-10.479L2.384,-11.8C2.049,-11.918 1.517,-12.036 0.847,-12.036C0.039,-12.036 -0.611,-11.76 -1.024,-11.308C-1.497,-10.775 -1.694,-9.929 -1.694,-8.806L-1.694,-3.604L-3.172,-3.604L-3.172,-2.285L-1.694,-2.285L-1.694,-0.512L0,0Z",
    style: {
      fill: "rgb(26,31,113)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path4185",
    transform: "matrix(1,0,0,1,353.969,362.562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0C0,1.123 -0.021,2.088 -0.079,2.975L1.438,2.975L1.517,1.084L1.575,1.084C2.009,2.364 3.072,3.172 4.234,3.172C4.412,3.172 4.55,3.152 4.708,3.133L4.708,1.497C4.53,1.537 4.354,1.537 4.116,1.537C2.896,1.537 2.028,0.631 1.792,-0.67C1.753,-0.906 1.733,-1.201 1.733,-1.478L1.733,-6.56L0,-6.56L0,0Z",
    style: {
      fill: "rgb(26,31,113)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path4189",
    transform: "matrix(1,0,0,1,361.786,360.749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0C0,-2.088 1.182,-3.664 2.876,-3.664C4.531,-3.664 5.771,-2.107 5.771,0.04C5.771,1.655 4.964,3.685 2.915,3.685C0.887,3.685 0,1.793 0,0M7.545,0.099C7.545,-3.427 5.082,-4.964 2.797,-4.964C0.236,-4.964 -1.772,-3.072 -1.772,-0.059C-1.772,3.113 0.335,4.984 2.955,4.984C5.693,4.984 7.545,2.995 7.545,0.099",
    style: {
      fill: "rgb(26,31,113)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path4193",
    transform: "matrix(1,0,0,1,371.987,362.956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0C0,1.004 -0.021,1.792 -0.079,2.58L1.457,2.58L1.556,1.004L1.595,1.004C2.068,1.891 3.171,2.777 4.747,2.777C6.066,2.777 8.115,1.989 8.115,-1.28L8.115,-6.954L6.382,-6.954L6.382,-1.458C6.382,0.078 5.811,1.359 4.176,1.359C3.053,1.359 2.166,0.551 1.852,-0.414C1.772,-0.631 1.733,-0.926 1.733,-1.222L1.733,-6.954L0,-6.954L0,0Z",
    style: {
      fill: "rgb(26,31,113)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaElectron);
export default __webpack_public_path__ + "static/media/visa_electron.c4bd1cbfa1feb69fd27e89038a2cb5bd.svg";
export { ForwardRef as ReactComponent };